import React from 'react';
import PropTypes from 'prop-types';
import Flex from '../common/Flex';
import Dot from '../common/Dot';

const ServiceWidgetItem = ({ color, name, value, totalShare }) => (
  <Flex justify="between" align="center" className="mb-1">
    <Flex align="center">
      <Dot style={{ backgroundColor: color }} />
      <span className="font-weight-semi-bold">
        {value === 0.01 ? '' : value} - {name}
      </span>
    </Flex>
    <div className="d-xxl-none">{((value * 100) / totalShare).toFixed(0)}%</div>
  </Flex>
);

ServiceWidgetItem.propTypes = {
  color: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  totalShare: PropTypes.number.isRequired
};

export default ServiceWidgetItem;
